import { Role, Visualization } from 'states';
import { DetailOutput } from './types';

/**
 * The payload that saves a gap KPI's click-through list. It is not placed on any dashboard; it only
 * opens from the number, so it carries the same roles as the KPI that opens it.
 * @param existingId Id of the list when this KPI is being edited, so it is updated rather than duplicated.
 */
export function buildDetailVisualization(detail: DetailOutput, roles: Role[], existingId?: number): Visualization {
  const viz: Visualization = {
    title: detail.title,
    isPinned: false,
    isDecimal: false,
    type: 'visualization',
    visualizationCode: detail.visualizationCode,
    visualizationPermission: [],
    data: [
      {
        info: { title: detail.title, subTitle: '', chartType: detail.chartType },
        data: { query: detail.queryString },
        access: { escapedAccessConfig: roles, accessConfig: JSON.stringify(roles) },
        dashboards: JSON.stringify([]),
        additionalConfig: { config: JSON.stringify(detail.config) },
      },
    ],
  };
  if (existingId) viz.id = existingId;
  return viz;
}
